<template>
  <div
    class="fixed top-0 left-0 z-20 flex h-full flex-col border-r border-gray-100 bg-white shadow-sm sm:flex"
    :class="expand ? 'w-full md:w-64 shadow-xl md:shadow-sm' : 'w-16 hidden'"
  >
    <div class="relative flex h-20 w-full flex-shrink-0 items-center justify-center border-b border-gray-100 bg-white p-3">
      <img
        v-if="!expand"
        src="/favicon.png"
        class="max-w-full max-h-full inline-block"
        alt="ev-angel-isch Logo"
      />
      <img
        v-else
        src="@/assets/logo.png"
        class="max-w-full max-h-full inline-block"
        alt="ev-angel-isch Logo"
      />
      <button
        v-if="expand"
        type="button"
        class="absolute bottom-2 right-2 !rounded-md !border-0 !bg-gray-100 !p-1.5 !text-gray-700 !shadow-none hover:!bg-primary hover:!text-white"
        aria-label="Navigation einklappen"
        @click="$emit('toggleMenu')"
      >
        <font-awesome-icon icon="arrow-left" class="text-base" />
      </button>
    </div>

    <div :class="expand ? 'px-3' : 'text-center'" class="flex-1 space-y-0.5 overflow-y-auto overflow-x-hidden">
      <font-awesome-icon
        v-if="!expand"
        icon="bars"
        class="text-2xl text-primary cursor-pointer"
        @click="$emit('toggleMenu')"
      />
      <div class="w-full">
        <a
          href="/"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Home' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="home"
            class=""
            :class="title === 'Home' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Home</span>
        </a>
      </div>
      <div v-if="user.Attendance > 0" class="w-full">
        <a
          href="/attendance"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Anwesenheit' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="person-circle-check"
            class=""
            :class="title === 'Anwesenheit' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Anwesenheit</span>
        </a>
      </div>
      <div v-if="user.Mealplan > 0" class="w-full">
        <a
          href="/mealplanning"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Essensplanung' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="utensils"
            class=""
            :class="title === 'Essensplanung' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold"
            >Essensplanung</span
          >
        </a>
      </div>
      <div v-if="user.Exporte > 0" class="w-full">
        <a
          href="/export"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Exporte' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="file-export"
            class=""
            :class="title === 'Exporte' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold"
            >Exporte</span
          >
        </a>
      </div>
      <div v-if="user.Contracts > 0 || (user.Contracts === 0 && user.restrictedViews)" class="w-full">
        <a
          href="/contracts"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Verträge' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="pen"
            class=""
            :class="title === 'Verträge' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Verträge</span>
        </a>
      </div>
      <div v-if="user.Customers > 0 || (user.Customers === 0 && user.restrictedViews)" class="w-full">
        <a
          href="/customers"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Kunden' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="person-circle-check"
            class=""
            :class="title === 'Kunden' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Kunden</span>
        </a>
      </div>
      <div v-if="user.Projects > 0 || (user.Projects === 0 && user.restrictedViews)" class="w-full">
        <a
          href="/projects"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Projekte' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="qrcode"
            class=""
            :class="title === 'Projekte' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Projekte</span>
        </a>
      </div>
      <div v-if="user.Contacts > 0" class="w-full">
        <a
          href="/contacts"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Kontakte' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="address-book"
            class=""
            :class="title === 'Kontakte' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Kontakte</span>
        </a>
      </div>
      <div v-if="user.Umfragen > 0" class="w-full">
        <a
          href="/polls"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Umfragen' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="list"
            class=""
            :class="title === 'Umfragen' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Umfragen</span>
        </a>
      </div>
      <div v-if="user.Maillist > 0" class="w-full">
        <a
          href="/distribution-lists"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Verteiler' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="envelope"
            class=""
            :class="title === 'Verteiler' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Verteiler</span>
        </a>
      </div>
      <div v-if="user.Employees > 0" class="w-full">
        <a
          href="/employees"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Mitarbeiter' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="users"
            class=""
            :class="title === 'Mitarbeiter' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Mitarbeiter</span>
        </a>
      </div>
      <div v-if="user.Announcements > 0" class="w-full">
        <a
          href="/announcements"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Ankündigungen' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="bullhorn"
            class=""
            :class="title === 'Ankündigungen' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Ankündigungen</span>
        </a>
      </div>
      <div v-if="user.Accounts > 0" class="w-full">
        <a
          href="/account-help"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Accounthilfe' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="user-gear"
            class=""
            :class="title === 'Accounthilfe' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Accounthilfe</span>
        </a>
      </div>
      <div v-if="user.Permissions > 0" class="w-full">
        <a
          href="/permissions"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Berechtigungen' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="key"
            class=""
            :class="title === 'Berechtigungen' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Berechtigungen</span>
        </a>
      </div>
      <div v-if="user.Import > 0" class="w-full">
        <a
          href="/import"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Import' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="file-import"
            class=""
            :class="title === 'Import' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Import</span>
        </a>
      </div>
      <div v-if="user.Maintenance > 0" class="w-full">
        <a
          href="/maintenance"
          class="nav-item flex w-full items-center gap-2 !border-0 !px-3 !py-1.5 text-left text-2xl !font-medium !shadow-none transition-all duration-150 hover:bg-primary/10"
          :class="title === 'Wartungsmodus' ? 'bg-primary/10 text-primary shadow-sm' : 'text-gray-600'"
        >
          <font-awesome-icon
            icon="screwdriver-wrench"
            class=""
            :class="title === 'Wartungsmodus' ? 'text-primary' : 'text-black'"
          />
          <span v-if="expand" class="ml-1 text-base font-bold">Wartungsmodus</span>
        </a>
      </div>
      <div v-if="canOpenChangelog" class="w-full">
        <button
          type="button"
          class="inline-block border-b-4 border-white text-3xl hover:border-primarylight cursor-pointer pt-3 text-left"
          @click="$emit('openChangelog')"
          aria-label="Versionsverlauf öffnen"
        >
          <font-awesome-icon icon="history" class="text-black" />
          <span v-if="expand" class="ml-1 text-base font-bold">Versionsverlauf</span>
        </button>
      </div>
      <div class="w-full mt-6">
        <a
          :href="evlineUrl"
          class="inline-block border-b-4 text-3xl hover:border-primarylight cursor-pointer pt-3 border-white"
        >
          <font-awesome-icon icon="lock" class="text-black" />
          <span v-if="expand" class="ml-1 text-base font-bold"
            >Zu "Anmeldung"</span
          >
        </a>
      </div>
    </div>

    <div class="flex-shrink-0 w-full text-center pb-2">
      <div class="">
        <button v-if="expand" class="full" @click="logout">Abmelden</button>
        <font-awesome-icon
          v-else
          class="text-3xl text-red-300 cursor-pointer mb-2"
          icon="right-from-bracket"
        />
      </div>
      <a
        v-if="expand"
        href="/impressum"
        class="text-sm mx-3 underline cursor-pointer text-gray-500 font-bold"
        >Impressum</a
      >
      <a
        v-if="expand"
        href="/datenschutz"
        class="text-sm mx-3 underline cursor-pointer text-gray-500 font-bold"
        >Datenschutz</a
      >
      <div v-if="expand" class="text-xs text-gray-400 font-semibold mt-1 mb-2">
        Version {{ version }}
      </div>
    </div>
  </div>
</template>
  
<script>
// @ is an alias to /src
import API from "@/API";
export default {
  name: "Header",
  props: ["title", "user", "expand"],
  emits: ["toggleMenu", "openChangelog"],
  data() {
    return {
      evlineUrl: process.env.VUE_APP_INTERNAL_URL,
      version: process.env.VUE_APP_VERSION,
    };
  },
  computed: {
    canOpenChangelog() {
      return Boolean(
        this.user &&
        this.user.Intern &&
        Number(this.user.Contracts) > 0 &&
        this.user.id !== undefined &&
        this.user.id !== null &&
        String(this.user.id).trim() !== ""
      );
    },
  },
  methods: {
    logout() {
      window.location = process.env.VUE_APP_BE_URL+"/online/auth/logout";
    },
  },
};
</script>
  